import React from 'react';
import styled from 'styled-components';
import { color, space } from 'styled-system';
import Text from 'theme/text';
import Edit from 'theme/icons/edit';
import Check from 'theme/icons/check';
import CircleStar from 'theme/icons/circle-star';
import translations from 'translations';

const Wrapper = styled.div`
  background-color: #fff;
  height: 36px;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;

  ${space}
`;

const Circle = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${color}
`;

function StatusLabel({ style, status, languageCode }) {
  return (
    <Wrapper {...style}>
      {status === 'DRAFT' && (
        <>
          <Circle bg="grey_150" color="grey_400">
            <Edit width="7" />
          </Circle>
          <Text fontSize="label" lineHeight="label" fontWeight="bold" color="grey_600" ml="xs">
            {translations[languageCode].Draft}
          </Text>
        </>
      )}
      {status === 'COMPLETE' && (
        <>
          <Circle bg="primary_400" color="white">
            <Check width="10" />
          </Circle>
          <Text fontSize="label" lineHeight="label" fontWeight="bold" color="grey_600" ml="xs">
            {translations[languageCode].Complete}
          </Text>
        </>
      )}
      {status === 'DEFAULT' && (
        <>
          <Circle bg="orange_400" color="white">
            <CircleStar />
          </Circle>
          <Text fontSize="label" lineHeight="label" fontWeight="bold" color="grey_600" ml="xs">
            {translations[languageCode].Default}
          </Text>
        </>
      )}
    </Wrapper>
  );
}

export default StatusLabel;
